"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {hasClass, removeClass, addClass, on, find} from "@elements/dom-utils";
import {activateScrollLock, deactivateScrollLock} from "@elements/scroll-lock";

export function init () {
    onFind('.js-overlay-toggle', function ($toggleButton) {
        on('click', function () {
            let $overlay = find($toggleButton.getAttribute('data-overlay-target'));
            const isMobile = () => matchMedia('(max-width: 767px)').matches;

            if (isMobile()) {
                if (hasClass('is-open', $overlay)) {
                    removeClass('is-open', $overlay);
                    deactivateScrollLock();
                } else {
                    addClass('is-open', $overlay);
                    activateScrollLock();
                }
            }
        }, $toggleButton);
    });
}